import type {
  ApiUnsubscribeGroup,
  ApiUnsubscribeGroupsResponse,
  UnsubscribeGroup,
  UnsubscribeGroupsData,
} from '../types';

export function mapUnsubscribeGroup(group: ApiUnsubscribeGroup): UnsubscribeGroup {
  return {
    id: group.id,
    name: group.name,
    description: group.description,
    isDefault: group.is_default,
    isArtistDefault: group.is_artist_default,
    unsubscribes: group.unsubscribes,
  };
}

export function mapUnsubscribeGroupsResponse(response: ApiUnsubscribeGroupsResponse): UnsubscribeGroupsData {
  return {
    available: response.available,
    groups: (response.groups ?? []).map(mapUnsubscribeGroup),
  };
}
